module.exports = __webpack_public_path__ + "assets/icons/quick-haul-active.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/jobcategories/quick-haul-active.png
// module id = ./src/styles/icons/jobcategories/quick-haul-active.png
// module chunks = 0